import { materialTypeForAssay } from 'shared/helpers/constants/packages/materialType';

const setProcessingDefaultMaterialType = ({ packages }) => {
  const packageTotal = packages.length;

  const materialTypesCount = packages.reduce(
    (acc, { materialTypeDeclared }) => {
      switch (materialTypeDeclared) {
        case materialTypeForAssay.DPF_canned:
        case materialTypeForAssay.DPF_decanned:
          acc.DPF_decanned++;
          break;
        case materialTypeForAssay.sensors:
          acc.sensors++;
          break;
        case materialTypeForAssay.foil_canned:
        case materialTypeForAssay.foil_decanned:
          acc.foil_decanned++;
          break;
        default:
          break;
      }
      return acc;
    },

    { DPF_decanned: 0, sensors: 0, foil_decanned: 0 },
  );

  const materialTypesPercentages = [
    {
      type: materialTypeForAssay.DPF_decanned,
      value: materialTypesCount.DPF_decanned / packageTotal,
    },
    { type: materialTypeForAssay.sensors, value: materialTypesCount.sensors / packageTotal },
    {
      type: materialTypeForAssay.foil_decanned,
      value: materialTypesCount.foil_decanned / packageTotal,
    },
  ];

  return (
    materialTypesPercentages.find(material => material.value >= 0.9 && material.type)?.type || false
  );
};

export { setProcessingDefaultMaterialType };
